export const COUNTRY_OPTIONS = [
  { value: "India", label: "India" },
  { value: "Kenya", label: "Kenya" },
  { value: "ASEAN", label: "Southeast Asia" },
];

export const SECTOR_OPTIONS = [
  { value: "energy_efficiency", label: "Energy Efficiency" },
  { value: "demand_flexibility", label: "Demand Flexibility" },
  { value: "sustainable_cooling", label: "Sustainable Cooling" },
];

export const CATEGORY_OPTIONS = [
  { value: "Elevate", label: "Elevate" },
  { value: "Support", label: "Support" },
  { value: "Invest", label: "Invest" },
];

export const PAGE_OPTIONS = [
  {
    value: "global_ambition_taskforce",
    label: "Global Ambition Taskforce",
  },
  {
    value: "narrative_taskforce",
    label: "Narrative Taskforce",
  },
  {
    value: "marketplace_taskforce",
    label: "Marketplace Taskforce",
  },
  { value: "cop", label: "COP" },
  { value: "call_to_action", label: "Call to Action" },
];

/**
 * Normalizes selected values by matching them against a list of options.
 * This ensures consistent casing and display labels.
 */
export const normalizeFilterValues = (
  selected: string[],
  options: { value: string; label: string }[]
) => {
  return selected.map((val) => {
    const found = options.find(
      (opt) => opt.value.toLowerCase() === val.toLowerCase()
    );
    return found ? found.value : val;
  });
};
